import AuthService from "./AuthService";
import AuthApi from "./AuthApi";
import environment from "../../environment";
import BaseApi from "../BaseApi";

export default class AuthRUService extends AuthService {
    static iniciarLoginUnificado() {
        window.location.href = `${environment.loginUnificadoUrl}/${environment.sistema}`;
    }

    // Ajustado para receber o objeto com code e state
    static completeMfa(params) {
        return AuthApi.post(`v2/authenticate/mfa/finalize`, params).then(
            result => {
                const authorization = result.data.data;

                if (authorization.user.menus.length === 0) {
                    AuthRUService.gerarPermissao(Number.parseInt(authorization.user.ru));
                }
                if (authorization && authorization.token)
                    this._saveCredentials(authorization);

                return authorization.user.nome;
            }
        );
    }

    static async finalizarLoginComSessao(sessionId) {
        try {
            const response = await AuthApi.post(`v2/authenticate/finalize`, {
                mfaSessionId: sessionId
            });

            const data = response.data.data;
            const token = data.Token || data.token;
            const userRaw = data.User || data.user;

            if (token && userRaw) {
                const authorization = {
                    token: token,
                    user: {
                        matricula: userRaw.Matricula || userRaw.matricula,
                        email: userRaw.Email || userRaw.email,
                        nome: userRaw.Nome || userRaw.nome,
                        ru: userRaw.Ru || userRaw.ru,
                        menus: userRaw.Menus || userRaw.menus || [],
                        sistemas: userRaw.Sistemas || userRaw.sistemas || []
                    }
                };

                this._saveCredentials(authorization);

                if (authorization.user.menus.length === 0) {
                    await this.gerarPermissao(Number.parseInt(authorization.user.ru));
                }
                return true;
            }
            return false;
        } catch (e) {
            console.error("Erro na troca de sessão:", e);
            return false;
        }
    }

    static gerarPermissao(ru) {
        return BaseApi.post(`Permissao/v1/permissao`, { ru }).then(result => {
            if (result === true || result.data === true) {
                return AuthRUService.refreshCredentials();
            }
        });
    }

    static async refreshCredentials() {
        return AuthApi.get(`v1/authenticate/refreshcredentials/${environment.sistema}`, {
            headers: { authorization: `Bearer ${this.getToken()}` }
        }).then(response => {
            const data = response.data.data || response.data;
            if (data && (data.token || data.Token)) {
                this._saveCredentials(data);
                return true;
            }
            return false;
        });
    }
}